import React from 'react';
import { ProgressBar } from 'shared/ProgressBar';
import { Button } from 'shared/Button/NewButton';
import { CheckmarkCircleIcon } from 'shared/Icon/components/CheckmarkCircleIcon';
import {
  getStatusHeading,
  getStatusLabel,
} from 'screens/EpisodeOptionsScreen/components/EpisodeContent/UploadingState/utils';
import {
  ContentWrapper,
  uploaderCancelButtonStyle,
  UploaderContainer,
  UploaderContentsContainer,
  uploaderRetryButtonStyle,
  UploaderStatusContainer,
  UploaderStatusHeading,
  UploaderStatusLabel,
} from '../styles';
import { IconWrapper } from './styles';

type UploadingStateProps = {
  percentageComplete?: number;
  onCancelUpload?: () => void;
  onRetryUpload?: () => void;
  onCancelProcessing?: () => void;
  isUploading?: boolean;
  isProcessing?: boolean;
  isError?: boolean;
};

export const UploadingState = ({
  percentageComplete = 100,
  onCancelUpload,
  onRetryUpload,
  onCancelProcessing,
  isUploading,
  isProcessing,
  isError,
}: UploadingStateProps) => {
  return (
    <ContentWrapper>
      <UploaderContainer>
        <UploaderContentsContainer>
          <UploaderStatusHeading>
            {getStatusHeading(isProcessing, isError, percentageComplete)}
          </UploaderStatusHeading>
          <UploaderStatusLabel>
            {getStatusLabel(isProcessing, isError, percentageComplete)}
          </UploaderStatusLabel>
        </UploaderContentsContainer>
        <UploaderStatusContainer>
          {isUploading && percentageComplete < 100 && (
            <Button
              color="white"
              className={uploaderCancelButtonStyle}
              onClick={onCancelUpload}
            >
              Cancel
            </Button>
          )}
          {isError && isProcessing && (
            <Button
              color="white"
              className={uploaderCancelButtonStyle}
              onClick={onCancelProcessing}
            >
              Cancel
            </Button>
          )}
          {isError && !isProcessing && (
            <Button
              color="white"
              className={uploaderRetryButtonStyle}
              onClick={onRetryUpload}
            >
              Retry
            </Button>
          )}
          {isUploading && percentageComplete === 100 && (
            <IconWrapper>
              <CheckmarkCircleIcon />
            </IconWrapper>
          )}
        </UploaderStatusContainer>
      </UploaderContainer>
      <ProgressBar percentage={percentageComplete} height={4} />
    </ContentWrapper>
  );
};
